export const normalizeAccessCode = (input: string): string => {
  return input.replace(/[\s-]/g, '').toLowerCase()
}

export const formatAccessCode = (code: string): string => {
  const normalized = normalizeAccessCode(code).toUpperCase()
  return normalized.replace(/(.{3})(?=.)/g, '$1-')
}
